export default "__VITE_ASSET__CfimagiM__"